import { useCurrentUser } from "@/contexts";

import { NAV_LINK_GROUPS } from "./NavLink.constants";
import { NavLinksGroup } from "./NavLink.types";
import { useNavLinkItemFilter } from "./useNavLinkItemFilter";

export const useNavLinkGroups = (): NavLinksGroup[] => {
  const filterNavLinkItem = useNavLinkItemFilter();
  const currentUser = useCurrentUser();
  const isSuperAdmin = currentUser.role === "superAdmin";

  return NAV_LINK_GROUPS.filter((group) => group.type !== "superData" || isSuperAdmin)
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => filterNavLinkItem(item.type)),
    }))
    .filter((group) => group.items.length > 0);
};
